import { useLingui } from "@lingui/react/macro"

interface Props {
  className?: string
}

export function SuccessCheckIcon(props: Props) {
  const { t } = useLingui()

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{t`Success Check Icon`}</title>
      <circle cx="12" cy="12.5" r="9" fill="#FAFF00" />
      <path
        d="M8 11.8333L10.7826 14.5L16 9.5"
        stroke="#0A0A0A"
        strokeWidth="1.5"
      />
    </svg>
  )
}
